import { IGetAllSatisfacaoClienteUseCase } from "../../../presentation/useCases/read/get_all_satisfacao_cliente_use_case";
import { BasePaginatedUseCase } from "../../../../../common/domain/useCases/base_paginated_use_case";
import { SatiscacaoClienteLista } from "../../models/satisfacao_cliente_lista";
import { IEntregaObrasRepository } from "../../repositories/entrega_obras_repositories";

/**
 * GetAllSatisfacaoClienteUseCase
 */

export class GetAllSatisfacaoClienteUseCase
  extends BasePaginatedUseCase<SatiscacaoClienteLista>
  implements IGetAllSatisfacaoClienteUseCase {
  constructor(private readonly repository: IEntregaObrasRepository) {
    super();
  }

  async getAllSatisfacaoCliente(
    centroCustos: number[] | null,
    status: number | null,
    clientes: number[] | null,
    pesquisaCliente: string | null,
    page: number,
    rowsPerPage: number,
  ): Promise<void> {
    const result = await this.repository.getAllSatisfacaoCliente(
      centroCustos,
      status,
      clientes,
      pesquisaCliente,
      page,
      rowsPerPage,
    );

    this._items = result.items;
    this._totalItems = result.totalItems;
    this._currentPage = result.currentPage;
    this._pageSize = result.pageSize;
  }
}
